// --- Cookie Helpers ---
function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

function getCookie(name) {
  return document.cookie.split('; ').find(row => row.startsWith(name + '='))?.split('=')[1];
}

// --- Popup Component ---
if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-dismissed`;

        // --- AUTO SHOW ON FIRST PAGE LOAD (only once) ---
        if (!Shopify.designMode && !getCookie(this.cookie)) {
          window.addEventListener('load', () => {
            this.open();
            setCookie(this.cookie, true, this.dataset.dismissDays || 30);
          });
        }

        // --- ALWAYS OPEN WHEN CLICKING LINK WITH #load-popup ---
        document.addEventListener('click', (e) => {
          const link = e.target.closest('a[href="#load-popup"]');
          if (link) {
            e.preventDefault();
            this.open(); // always open
            history.replaceState(null, '', window.location.pathname + window.location.search);
          }
        });

        // --- DESIGN MODE SUPPORT ---
        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });
          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        }
      }

      close() {
        super.close();
        setCookie(this.cookie, true, this.dataset.dismissDays || 30);
      }
    }

    customElements.define('pop-up', PopUp);
  });
}
